module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAGklEQVQ4y2NgGAVEg/9EAMo0jHp61NOjAAgAUWrXKeQhPE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Header/hamburger.png
// module id = 268
// module chunks = 0